<template>
  <div
    id="side"
    class="relative bg-neutral-50 h-auto shadow flex-shrink-0 w-0 overflow-hidden pt-8"
  >
    <div
      class="md:fixed h-[100vh] md:w-[inherit] w-100% overflow-hidden overflow-y-scroll"
    >
      <div class="px-2 flex items-center gap-1 text-neutral-600">
        <span class="material-symbols-outlined text-md rotate-45">
          push_pin
        </span>
        <span class="text-md font-bold">Pinned</span>
      </div>
      <div class="flex flex-col gap-1 p-2">
        <div v-for="(item, i) in pinned" :key="i">
          <SidebarLink :item="item"></SidebarLink>
        </div>
        <div v-if="this.currentRoute">
          <div
            class="text-primary cursor-pointer text-xs flex items-center"
            v-if="!this.currentRoute.pinned"
            @click="pin()"
          >
            <span class="material-symbols-outlined"> push_pin </span>
            <p>Pin {{ currentRoute.label }}</p>
          </div>
          <div
            class="text-primary cursor-pointer text-xs flex items-center"
            v-else
            @click="unpin()"
          >
            <span class="material-symbols-outlined rotate-90"> push_pin </span>
            <p>Unpin {{ currentRoute.label }}</p>
          </div>
        </div>
      </div>
      <div
        class="px-2 flex items-center gap-1 text-neutral-600 mt-2 cursor-pointer"
        @click="isAllExpanded = !isAllExpanded"
      >
        <span
          class="material-symbols-outlined text-md cursor-pointer transition-all duration-500"
          :class="isAllExpanded ? 'rotate-180' : ''"
        >
          expand_more
        </span>
        <span class="text-md font-bold">All</span>
      </div>
      <div class="p-2 pb-0" v-if="isAllExpanded">
        <input
          v-model="searchQ"
          type="text"
          placeholder="Search Pages"
          class="p-1 border border-neutral-200 rounded-md w-full text-sm"
        />
      </div>
      <div
        class="flex-col gap-1 p-2 h-[80vh] pb-[20vh] overflow-hidden overflow-y-scroll max-h-0 opacity-0 transition-all hidden"
        :class="isAllExpanded ? 'max-h-full opacity-100 !flex' : ''"
      >
        <SidebarLink
          v-for="(item, i) in links"
          :key="i"
          :item="item"
        ></SidebarLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import SidebarLink from "./SideBarLink.vue";
import { Routes } from "./../../../enums/routes.enum";
import { StorageKeys } from "@/enums/storageKeys.enum";
import Vue from "vue";
import { PermissionsSlugs } from "@/enums/permissions.enum";
import { mapGetters } from "vuex";
import store from "././../../../store";
import { linksData } from "./links";
import { Link } from "./link";
export default Vue.extend({
  components: {
    SidebarLink,
  },
  data() {
    return {
      user: localStorage.getItem(StorageKeys.user),
      showMobileMenu: false,
      showProfileMenu: false,
      isAllExpanded: false,
      linksArray: new Array<Link>(),
      linksData,
      searchQ: "",
      PermissionsSlugs,
    };
  },
  computed: {
    ...mapGetters(["havePermission", "sidebarPinnedLinks"]),
    currentRoute(): any {
      let link = this.linksArray.find((l) => l.destination == this.$route.name);
      if (!link) {
        let parents = this.linksArray.filter((l) => l.children != undefined);
        parents.forEach((p) => {
          link = p.children!.find((l) => l.destination == this.$route.name);
        });
      }
      return link;
      // return this.linksArray.find((l) => l.destination == this.$route.name);
    },
    pinned(): Array<any> {
      let pinned = this.linksArray.filter(
        (l) =>
          l.pinned == true &&
          l.isPermitted &&
          !(
            l.children &&
            l.children.length > 0 &&
            l.children.every((c: any) => !c.isPermitted)
          )
      );
      // add pinned children
      let parents = this.linksArray.filter(
        (l) => l.children != undefined && l.children.length > 0
      );
      let pinnedChildren: Link[] = [];

      parents.forEach((p) => {
        let pinnedChilds = (p as any).children.filter(
          (c: Link) => c.pinned == true && c.isPermitted
        );
        pinnedChildren = pinnedChildren.concat(pinnedChilds);
      });
      pinned = pinned.concat(pinnedChildren);
      return pinned;
    },
    links(): Array<any> {
      return this.linksArray.filter(
        (l) =>
          l.pinned == false &&
          l.label.toLowerCase().includes(this.searchQ.toLowerCase()) &&
          l.isPermitted &&
          !(
            l.children &&
            l.children.length > 0 &&
            l.children.every((c: any) => !c.isPermitted)
          )
      );
    },
  },
  methods: {
    pin() {
      this.currentRoute.pinned = true;
      this.$forceUpdate();
      this.setLinks();
    },
    unpin() {
      this.currentRoute.pinned = false;
      this.$forceUpdate();
      this.setLinks();
    },
    setLinks() {
      store.dispatch(
        "setSidebarPinnedLinks",
        this.pinned.map((l) => l.destination)
      );
    },
    parseLabels() {
      this.linksArray.forEach((l) => {
        (l.label as any) = this.$i18n.t(l.label);
        l.pinned = false;
        if (l.children) {
          l.children.forEach((child) => {
            (child.label as any) = this.$i18n.t(child.label);
          });
        }
      });
    },
    parsePinned() {
      this.linksArray.forEach((l) => {
        if (!this.sidebarPinnedLinks) return;
        if (this.sidebarPinnedLinks.includes(l.destination)) l.pinned = true;
      });
      let parents = this.linksArray.filter(
        (l) => l.children != undefined && l.children.length > 0
      );
      parents.forEach((parent) => {
        parent.children?.forEach((child) => {
          if (
            this.sidebarPinnedLinks &&
            this.sidebarPinnedLinks.includes(child.destination)
          )
            child.pinned = true;
        });
      });
    },
    parsePermissions() {
      this.linksArray.forEach((l) => {
        l.isPermitted = this.isLinkPermitted(l);
      });
      let parents = this.linksArray.filter(
        (l) => l.children != undefined && l.children.length > 0
      );
      parents.forEach((parent) => {
        parent.children?.forEach((child) => {
          child.isPermitted = this.isLinkPermitted(child, true);
        });
      });
    },
    isLinkPermitted(link: Link, useEveryForPermissions = false) {
      if (link.anyPermissions && link.anyPermissions.length > 0) {
        return link.anyPermissions.some((p) => this.havePermission(p));
      }
      if (link.permissions.length == 0) return true;
      if (useEveryForPermissions) {
        return link.permissions.every((p) => this.havePermission(p));
      }
      return link.permissions.some((p) => this.havePermission(p));
    },
    parseLinks() {
      this.linksData.forEach((d: any) => {
        this.linksArray.push(new Link(d));
      });
    },
  },
  watch: {
    "$store.state.user.permissions": {
      handler() {
        this.parsePermissions();
      },
      deep: true,
    },
  },
  mounted() {
    this.$root.$on("PermissionsChanged", (data: any) => {
      this.parsePermissions();
    });
    this.parseLinks();
    this.parseLabels();
    this.parsePinned();
    this.parsePermissions();
  },
});
</script>

<style>
.shown {
  width: auto !important;
}
</style>
